import * as React from 'react';
import { SVGProps } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#edit_svg__a)' fill='#000'>
      <path d='M22.5 20.5h-21V22h21v-1.5ZM19.05 7.75c.6-.6.6-1.5 0-2.1l-2.7-2.7c-.6-.6-1.5-.6-2.1 0L3 14.2V19h4.8L19.05 7.75ZM15.3 4 18 6.7l-2.25 2.25-2.7-2.7L15.3 4ZM4.5 17.5v-2.7L12 7.3l2.7 2.7-7.5 7.5H4.5Z' />
    </g>
    <defs>
      <clipPath id='edit_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEdit;
